import { Outlet, Link } from "react-router-dom";
import Pdf from "./resources/resume-shreyas.pdf";

export const NavButton = ({ buttonName, redirectPath }) => (
    <div className="text-center p-2 h-10 bg-gradient-to-r from-red-400 to-pink-500 rounded-lg md:bg-transparent">
        <a href={redirectPath} className="hover:border-b-4 font-bold">{buttonName}</a>
    </div>
);

export const NavigationBar = () => {
    return (
        <div className="w-full z-10 flex justify-center pt-5">
            <div className="flex flex-col md:flex-row justify-between w-10/12 ">
                <div className="p-2 font-mono text-lg md:text-2xl font-bold">Shreyas Thirumalai</div>
                <div className="flex flex-row gap-4">
                <NavButton buttonName={"Projects"} redirectPath={`/personal-site/#/projects`} />
                <NavButton buttonName={"Blog"} redirectPath={`/personal-site/#/blog`} />
                <NavButton buttonName={"Travel"} redirectPath={`/personal-site/#/travel`} />
                <div className="text-center p-2 h-10 bg-gradient-to-r from-red-400 to-pink-500 rounded-lg md:bg-transparent">
                    <a href={Pdf} rel="noreferrer" target="_blank" className="hover:border-b-4 font-bold">Resume</a>
                </div>
                {/* <NavButton buttonName={"Resume"} redirectPath={`/resume`} /> */}
                </div>
            </div>
        </div>
        
    );
};

export default NavigationBar;